import {useEffect} from 'react';
import { Dropdown, Menu } from 'antd';
import { useDispatch } from 'react-redux';
import * as actionsGridView from 'common/components/grid-view/controllers/actions';
import { useFilterGrid } from 'hooks/useFilterGrid';
import { useDisplayFilterButton } from 'hooks/useDisplayFilterButton';
import { useQueryClient } from '@tanstack/react-query';
import { RibbonButton } from 'common/components';
import { FILTER_GR_EVAL_FORM } from 'static/Constants';

const { SubMenu } = Menu;

const FilterGREvalFormList = (props) => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const { entityType = 'grEvalForm' } = props;


  const filterOptions = [...FILTER_GR_EVAL_FORM];

  const { gridFilters, updateGridFilter } = useFilterGrid({
    entityType,
  });

  // useEffect(() => {
  //   updateGridFilter(['notStarted', 'inProgress']);
  // }, []);

  const { label, icon, toggle } = useDisplayFilterButton({
    filterOptions: filterOptions,
    filters: gridFilters.filter((filterItem) => {
      return filterOptions.find(
        (FILTER_ITEM) => FILTER_ITEM.value === filterItem
      );
    }),
  });

  const handleFilter = (filter) => {
    dispatch(actionsGridView.resetPageCurrent());
    if (gridFilters.indexOf(filter) > -1) {
      updateGridFilter(gridFilters.filter((val) => val !== filter));
    } else {
      let newFilter = [...gridFilters];
      newFilter.push(filter);
      updateGridFilter(newFilter);
    }
  };

  

  const menuOptions = (
    <Menu>
      {FILTER_GR_EVAL_FORM.map((menuItem, index) => (
        <Menu.Item
          style={{
            backgroundColor: 'inherit',
          }}
          key={menuItem.value}
        >
          <RibbonButton
            size='small'
            label={menuItem.label}
            icon={menuItem.icon}
            toggle={gridFilters?.includes(menuItem.value)}
            onClick={() => handleFilter(menuItem.value)}
          />
        </Menu.Item>
      ))}

    </Menu>
  );

  return (
    <Dropdown overlay={menuOptions} placement='bottomLeft' arrow>
      <RibbonButton icon={icon} label={label} toggle={toggle} />
    </Dropdown>
  );
};

export default FilterGREvalFormList;
